import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Button from '@atlaskit/button/default/button';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Text } from '@atlaskit/primitives/compiled/text';

const messages = defineMessages({
	showMore: {
		id: 'byline-connections.show-more-button.label',
		defaultMessage: 'Show more',
		description:
			'Button below a connections list that shows more connections using the action provided by the containing section.',
	},
});

export type ShowMoreButtonProps = {
	onClick: () => void;
};

export const ShowMoreButton = ({ onClick }: ShowMoreButtonProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Box paddingInline="space.100" paddingBlockEnd="space.100">
			<Button appearance="subtle" spacing="compact" onClick={onClick}>
				<Text weight="regular" color="color.text.subtlest">
					{formatMessage(messages.showMore)}
				</Text>
			</Button>
		</Box>
	);
};
